import { formatNumberWithCommas } from '../../../utils';

// GoodCode trong tblGoods_Master (quản lý ở trang admin MAAAA001)
export const GOODS_CODE = {
    BUSINESS_BANNER: '01',
    GRAND_BANNER: '02',
    GRAND_BANNER_FIXED: '03',
    PREMIUM_BANNER: '04',
    PREMIUM_BANNER_FIXED: '05',
    HOT_RECRUIT_BANNER: '06',
    HOT_RECRUIT_BANNER_FIXED: '07',
    COMPANY_BANNER: '08',
    RECRUIT_NEWS: '09',
    RECRUIT_NEWS_FIXED: '10',
    HIGHLIGHT_1W: '11',
    HIGHLIGHT_2W: '12',
    COLOR_1W: '13',
    COLOR_2W: '14',
};

export const toGoodsMap = (list) => Object.fromEntries((list || []).map((goods) => [goods.goodCode, goods]));

const renderPrice = (price) =>
    price ? (
        <span>
            <b>{formatNumberWithCommas(price)}</b>원
        </span>
    ) : (
        <span>-</span>
    );

// Sản phẩm không có trong DB hoặc UseYN = 'N' thì không hiển thị dòng giá
const GoodsPriceRow = ({ goods }) => {
    if (!goods) return null;
    return (
        <div className="ticket__grid">
            <span className="left">{goods.goodName}</span>
            {renderPrice(goods.priceDJ)}
            {renderPrice(goods.priceDVMall)}
            {renderPrice(goods.priceDVMember)}
        </div>
    );
};

export default GoodsPriceRow;
